var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight = function SvgArrowRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m231.9 154.5 320.4 320.4c14.7 14.7 14.7 37.7 0 50.3L231.9 847.6c-35.6 35.6-35.6 92.1 0 125.7 35.6 35.6 92.1 35.6 125.7 0l410.5-410.5c35.6-35.6 35.6-92.1 0-125.7L359.7 26.7c-35.6-35.6-92.1-35.6-125.7 0-35.6 35.6-35.6 92.1-2.1 127.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export default ForwardRef;